import { Box, Button, Grid, Dialog, Paper, DialogActions, DialogContentText, DialogContent, DialogTitle, Snackbar } from "@material-ui/core";
import _ from "lodash";
import axios from "axios";
import { useOktaAuth } from "@okta/okta-react";
import { useDispatch } from "react-redux";
import { getRequests } from "../../actions";
import { useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";

import BrandIcons from "../Common/BrandIcons";
import RoleIcons from "../Common/RoleIcons";
import RequestsBreadcrumb from "./RequestsBreadcrumb";
import LocationIcons from "../Common/LocationIcons";

const Alert = (props) => {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
};

const PendingRequestReadOnly = ({ item }) => {
    const dispatch = useDispatch();
    const { oktaAuth, authState } = useOktaAuth();
    const [modalOpen, setModalOpen] = useState(false);
    const [toastOpen, setToastOpen] = useState(false);
    const [toastContent, setToastContent] = useState("");
    const toggleModal = () => setModalOpen(!modalOpen);
    const resetStatus = () => {
        setModalOpen(true);
    };
    const confirmStatusReset = async () => {
        console.log("resetting status to pending");
        setModalOpen(!modalOpen);
        const token = oktaAuth.getAccessToken();
        axios
            .post(
                `${process.env.REACT_APP_APIHOST}/api/resetrequeststatus`,
                {
                    item,
                },
                {
                    headers: {
                        authorization: `Bearer ${token}`,
                    },
                }
            )
            .then((res) => {
                console.log(res.data);
                if (res.data.success) {
                    setToastContent(
                        <Alert onClose={handleToastClose} severity='success'>
                            {res.data.message}
                        </Alert>
                    );
                } else {
                    setToastContent(
                        <Alert onClose={handleToastClose} severity='error'>
                            {res.data.message}
                        </Alert>
                    );
                }
                setToastOpen(true);
            })
            .catch(function (error) {});
    };

    const handleToastClose = (event, reason) => {
        const token = oktaAuth.getAccessToken();
        if (reason === "clickaway") {
            dispatch(getRequests(token));
            return;
        }
        setToastOpen(false);
        dispatch(getRequests(token));
    };
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper>
                        <Box p={1}>
                            <RequestsBreadcrumb item={item} />
                        </Box>
                        <Box p={1}>
                            <div>
                                <strong>Request ID: </strong>
                                {item.id}
                            </div>
                            <div>
                                <strong>Name: </strong>
                                {item.firstName} {item.lastName}
                            </div>
                            <div>
                                <strong>Email: </strong>
                                {item.email}{" "}
                            </div>
                            <div>
                                <strong>Role: </strong>
                                <RoleIcons slug={item.userRole} label={true} />
                            </div>
                            <div>
                                <strong>Location: </strong>
                                <LocationIcons slug={item.location} label={true} />
                            </div>
                            <div>
                                <strong>Brands: </strong>
                                {_.map(_.compact(item.assocBrands.split(";")), (brand, i) => {
                                    return <BrandIcons key={i} slug={brand} location={item.location} label={true} />;
                                })}
                            </div>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
};

export default PendingRequestReadOnly;
